import type { SVGProps } from 'react'
const SvgOfflinePin = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="offline-pin_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#offline-pin_svg__a)">
      <path
        d="M6 12.75h6v-1.5H6zm2.213-2.25 4.237-4.237-1.069-1.032L8.213 8.4 6.6 6.787l-1.05 1.05zm.787 6a7.3 7.3 0 0 1-2.925-.59 7.6 7.6 0 0 1-2.381-1.604 7.6 7.6 0 0 1-1.603-2.381A7.3 7.3 0 0 1 1.5 9q0-1.556.59-2.925a7.6 7.6 0 0 1 1.604-2.381A7.6 7.6 0 0 1 6.075 2.09 7.3 7.3 0 0 1 9 1.5q1.555 0 2.925.59a7.6 7.6 0 0 1 2.381 1.604 7.6 7.6 0 0 1 1.603 2.381Q16.5 7.444 16.5 9a7.3 7.3 0 0 1-.59 2.925 7.6 7.6 0 0 1-1.604 2.381 7.6 7.6 0 0 1-2.381 1.603A7.3 7.3 0 0 1 9 16.5M9 15q2.513 0 4.256-1.744T15 9t-1.744-4.256Q11.513 3 9 3T4.744 4.744 3 9t1.744 4.256Q6.487 15 9 15"
        fill="white"
      />
    </g>
  </svg>
)
export default SvgOfflinePin
